export enum OptInKeuze {
  Ja = "Ja",
  Nee = "Nee",
  Onbekend = "Onbekend",
}
export enum RelatieType {
  Particulier = "Particulier",
  Zakelijk = "Zakelijk",
  Leasemaatschappij = "Leasemaatschappij",
}
export interface PermissieViewModel {
  Messenger: OptInKeuze;
  Email: OptInKeuze;
  Telefoon: OptInKeuze;
  Post: OptInKeuze;
}

export type CommunicatieMedium = keyof PermissieViewModel;

export const communicatieMedia: { key: CommunicatieMedium; labelKey: string }[] = [
  { key: "Email", labelKey: "perEmail" },
  { key: "Messenger", labelKey: "perSMS" },
  { key: "Telefoon", labelKey: "perTelefoon" },
  { key: "Post", labelKey: "perPost" },
];

export interface GroepViewModel {
  Auto: PermissieViewModel;
  MerkModel: PermissieViewModel;
  Bedrijf: PermissieViewModel;
  Overig: PermissieViewModel;
  Enquetes: PermissieViewModel;
}

export interface OptInViewModel {
  Autobedrijf: GroepViewModel;
}

export interface RelatieViewModel {
  RelatieType: RelatieType;
  Optin: OptInViewModel;
  NietBenaderen: boolean|null;
}
